(() => {
  if (window.__andIceProductMotion) return;
  window.__andIceProductMotion = true;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  const desktop = matchMedia("(min-width: 761px)");
  const controllers = new Map();
  const revealed = new WeakSet();

  // Native modal dialogs work in both the hydrated app and script-only static export.
  let activeDialog;
  let dialogTrigger;
  let previousOverflow;
  function releaseDialog(event) {
    // Ignore a queued close from a dialog that was already replaced/reopened.
    if (event && (event.currentTarget !== activeDialog || activeDialog?.open)) return;
    activeDialog?.removeEventListener("close", releaseDialog);
    document.documentElement.style.overflow = previousOverflow ?? "";
    if (dialogTrigger?.isConnected) dialogTrigger.focus({ preventScroll: true });
    activeDialog = undefined;
    dialogTrigger = undefined;
  }
  function showProduct(dialog, focusSelector = ".product-dialog-close button") {
    if (activeDialog) {
      activeDialog.removeEventListener("close", releaseDialog);
      activeDialog.close();
    }
    activeDialog = dialog;
    dialog.showModal();
    dialog.scrollTop = 0;
    dialog.querySelectorAll("img").forEach(img => { img.loading = "eager"; });
    dialog.querySelector(focusSelector)?.focus({ preventScroll: true });
    dialog.addEventListener("close", releaseDialog);
  }
  function stepProduct(control) {
    const dialog = document.getElementById(control.dataset.productTarget);
    if (dialog && typeof dialog.showModal === "function") {
      showProduct(dialog, `[data-product-step="${control.dataset.productStep}"]`);
    }
  }
  document.addEventListener("click", event => {
    const step = event.target.closest?.("[data-product-step]");
    if (step && activeDialog?.contains(step)) { stepProduct(step); return; }
    const trigger = event.target.closest?.("[data-product-open]");
    if (!trigger || activeDialog) return;
    const dialog = document.getElementById(trigger.dataset.productOpen);
    if (!dialog || typeof dialog.showModal !== "function") return;
    dialogTrigger = trigger;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    showProduct(dialog);
  });
  document.addEventListener("keydown", event => {
    if (!activeDialog || event.altKey || event.ctrlKey || event.metaKey ||
        event.target.closest?.('input,textarea,select,[contenteditable="true"]')) return;
    const direction = event.key === "ArrowLeft" ? -1 : event.key === "ArrowRight" ? 1 : 0;
    if (!direction) return;
    const control = activeDialog.querySelector(`[data-product-step="${direction}"]`);
    if (control) { event.preventDefault(); stepProduct(control); }
  });

  function carousel(stage) {
    const radios = [...stage.querySelectorAll('input[type="radio"]')];
    const panels = [...stage.querySelectorAll(".featured-panel")];
    const button = stage.querySelector("[data-cycle-toggle]");
    if (!button || radios.length < 2) return () => {};
    let timer;
    let fadeTimer;
    let visible = false;
    let paused = false;
    const current = () => Math.max(0, radios.findIndex(radio => radio.checked));
    const allowed = () => visible && !paused && !reduced.matches && !document.hidden && stage.isConnected;
    // Hero frames must load even while display:none; keep lazy loading for the catalogue only.
    panels.forEach(panel => { panel.querySelector("img").loading = "eager"; });
    function schedule() {
      clearTimeout(timer);
      button.hidden = reduced.matches;
      const nextImage = panels[(current() + 1) % panels.length].querySelector("img");
      const ready = nextImage.complete && nextImage.naturalWidth;
      button.textContent = paused ? button.dataset.play : !ready && allowed() ? button.dataset.loading : button.dataset.pause;
      button.setAttribute("aria-label", paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.setAttribute("aria-pressed", String(paused));
      stage.dataset.cycleState = reduced.matches ? "reduced" : allowed() ? ready ? "playing" : "loading" : "paused";
      if (!allowed()) return;
      timer = setTimeout(() => {
        if (!allowed()) return;
        const index = current();
        const next = (index + 1) % radios.length;
        const image = panels[next].querySelector("img");
        if (image.complete && image.naturalWidth) {
          panels.forEach(panel => { panel.classList.remove("is-leaving"); panel.removeAttribute("aria-hidden"); });
          panels[index].classList.add("is-leaving");
          panels[index].setAttribute("aria-hidden", "true");
          radios[next].checked = true;
          clearTimeout(fadeTimer);
          fadeTimer = setTimeout(() => { panels[index].classList.remove("is-leaving"); panels[index].removeAttribute("aria-hidden"); }, 600);
        }
        schedule();
      }, Number(stage.dataset.flavourCycle) || 2000);
    }
    // Choosing a dot restarts the two-second countdown; only the Pause button stops it.
    const manual = event => { if (event.target.matches('input[type="radio"]')) schedule(); };
    const toggle = () => { paused = !paused; schedule(); };
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; schedule(); }, { threshold: 0.3 });
    observer.observe(stage);
    stage.addEventListener("change", manual);
    button.addEventListener("click", toggle);
    document.addEventListener("visibilitychange", schedule);
    reduced.addEventListener("change", schedule);
    schedule();
    return () => {
      clearTimeout(timer); clearTimeout(fadeTimer); observer.disconnect();
      stage.removeEventListener("change", manual);
      button.removeEventListener("click", toggle);
      document.removeEventListener("visibilitychange", schedule); reduced.removeEventListener("change", schedule);
    };
  }


  function scan() {
    if (activeDialog && !activeDialog.isConnected) releaseDialog();
    controllers.forEach((dispose, stage) => {if (!stage.isConnected) {dispose(); controllers.delete(stage);}});
    document.querySelectorAll('[data-flavour-cycle]').forEach(stage => {if (!controllers.has(stage)) controllers.set(stage, carousel(stage));});
  }
  new MutationObserver(scan).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:block:select', event => {
    const section = event.target.closest('.product-line-page');
    const stage = section?.querySelector('[data-flavour-cycle]');
    const button = stage?.querySelector('[data-cycle-toggle]');
    if (stage?.dataset.cycleState === 'playing') button?.click();
  });
  scan();
})();
